import { useI18n } from "@/i18n/I18nContext";
import { motion } from "framer-motion";

const fadeUp = {
  initial: { y: 30, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, margin: "-40px" },
  transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
};

export default function LegalPage({ kind }) {
  const { t } = useI18n();
  const base = `pages.${kind}`;
  const sections = ["s1", "s2", "s3", "s4", "s5", "s6", "s7", "s8"];

  return (
    <main className="bg-[#F8F7F4] text-[#121316] pt-32 sm:pt-40 pb-24" style={{ wordBreak: "break-word" }}>
      <div className="max-w-4xl mx-auto px-5 sm:px-8 lg:px-12">
        <p className="text-[11px] font-mono uppercase tracking-[0.24em] text-[#7A7B82]">{t(`${base}.updated`)}</p>
        <h1 className="mt-6 font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1] tracking-tight">
          {t(`${base}.title`)}
        </h1>
        <p className="mt-8 text-lg text-[#3B3C42] leading-relaxed font-light max-w-3xl">
          {t(`${base}.intro`)}
        </p>

        <div className="mt-16 space-y-14">
          {sections.map((s) => {
            const title = t(`${base}.${s}Title`);
            const body = t(`${base}.${s}Body`);
            if (!title || title === `${base}.${s}Title`) return null;
            return (
              <motion.section key={s} {...fadeUp}>
                <h2 className="font-serif text-2xl sm:text-3xl leading-snug">{title}</h2>
                <p className="mt-4 text-[16px] text-[#52535A] leading-[1.75] font-light">{body}</p>
              </motion.section>
            );
          })}
        </div>
      </div>
    </main>
  );
}
